import {trans} from '@frontend/helpers'
import type {ExecutorPreviewData} from '@frontend/modules/public/services/ServicesModuleTypes'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {Collapse} from 'swayok-react-mdb-ui-kit/components/Collapse/Collapse'
import {ServicesListItem} from './ServicesListItem'

interface Props {
    executors: ExecutorPreviewData[]
    isAllExecutorsLoaded: boolean
    onLoadMore: () => void
    disabled?: boolean
    onExecutorDataChange?: (executor: ExecutorPreviewData) => void
    hideIfEmpty?: boolean
}

// Список исполнителей услуг для страницы поиска объявлений/услуг.
export function ServicesList(props: Props) {

    const {
        executors,
        isAllExecutorsLoaded,
        onLoadMore,
        disabled,
        onExecutorDataChange,
        hideIfEmpty,
    } = props

    if (!executors || executors.length === 0) {
        return hideIfEmpty
            ? null
            : (
                <div className="py-6 px-5 text-center fs-5">
                    {trans().services.list.no_services}
                </div>
            )
    }

    return (
        <div>
            <div
                id="search-results-list"
                className="d-grid grid-columns-1 row-gap-6"
            >
                {executors.map((item: ExecutorPreviewData) => (
                    <ServicesListItem
                        key={item.id}
                        executor={item}
                        onExecutorDataChange={onExecutorDataChange}
                    />
                ))}
            </div>

            <Collapse
                show={!isAllExecutorsLoaded}
                showImmediately
            >
                <div className="flex-center pt-3">
                    <Button
                        color="gray"
                        onClick={onLoadMore}
                        disabled={disabled}
                    >
                        {trans().common.load_more_records}
                    </Button>
                </div>
            </Collapse>
        </div>
    )
}
